import { Link } from 'react-router-dom';

import { Box, SxProps, Theme } from '@mui/material';

import { useActiveScope } from '~hooks/use-active-scope';

import { ROUTES } from '~app/router/routes';

type Props = {
  to?: string;
  variant?: 'full' | 'icon';
  width?: number;
  height?: number;
  sx?: SxProps<Theme>;
};

export const Logo = ({
  to = '/',
  variant = 'full',
  width = 146,
  height = 40,
  sx,
}: Props) => {
  const scope = useActiveScope();
  const src = `/branding/logo-${variant}-2.svg`;

  const toHref =
    scope === 'lessor' ? ROUTES.DASHBOARD : ROUTES.TENANT_SCOPE ?? '/';

  return (
    <Link to={toHref}>
      <Box
        component="img"
        src={src}
        alt="Rentify Logo"
        sx={{ ...sx, width, height }}
      />
    </Link>
  );
};
